const strings = {
  // Delete operations
  HOLDINGS_DELETED: "Holdings successfully deleted.",
  ERROR_DELETING_HOLDINGS: "An error occurred while deleting holdings.",
  ERROR_DELETING_HOLDINGS_GENERIC:
    "Failed to delete holdings. Please try again later.",

  // Create operations
  HOLDINGS_CREATED: "Holdings successfully created.",
  ERROR_CREATING_HOLDINGS: "An error occurred while creating holdings.",
  ERROR_CREATING_HOLDINGS_GENERIC:
    "Failed to create holdings. Please try again later.",

  // Update operations
  HOLDINGS_UPDATED: "Holdings successfully updated.",
  ERROR_UPDATING_HOLDINGS: "An error occurred while updating holdings.",
  ERROR_UPDATING_HOLDINGS_GENERIC:
    "Failed to update holdings. Please try again later.",
};

export default strings;
